import { CompanyStructureForPlanningResponse } from '@/types/service-response'
import _ from 'lodash'

export class Holiday {
  public constructor (
    readonly id: number,
    readonly date: string,
    readonly data?: any[]
  ) {}

  static createFromResponse (responseData: CompanyStructureForPlanningResponse): Array<Holiday> {
    let result: Array<Holiday> = []

    if (responseData.freitage) {
      const groupedByDate = _.groupBy(responseData.freitage, 'Datum')
      const groupedResult = _.map(groupedByDate, (itemsForDate, datum) => {
        const groupedByCode = _.groupBy(itemsForDate, 'Code')
        const dataForCode = _.map(groupedByCode, (itemsForCode, code) => {
          const firstItem = itemsForCode[0]
          return {
            code: code,
            bezeichnung: firstItem.Bezeichnung,
            land: _.map(_.groupBy(itemsForCode, 'LandISO'), (landItems, landISO) => ({
              landISO: landISO,
              bundesland: _.uniq(_.map(landItems, 'Bundesland')),
            })),
          }
        })

        return {
          datum: datum,
          data: dataForCode,
        }
      })

      if (groupedResult) {
        result = groupedResult.map((holiday: any, index: number) => {
          return new Holiday(
            index,
            holiday.datum,
            holiday.data
          )
        })
      }
    }

    return result
  }
}